<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import DriverSelect from "../components/controls/DriverSelect.svelte";
    import DriverSelectModal from "../transporters/DriverSelectModal.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let vehicle = null;
    export let changeHandler = null;

    let selectedDrivers = null;

    const save = (driverIds) => {
        const onSuccess = result => {
            if (result.length < vehicle.drivers.length) {
                Notifier.showMessage("Driver removed from vehicle");
            } else {
                Notifier.showMessage("Driver related to vehicle");
            }
            vehicle.drivers = result;
            if (changeHandler) {
                changeHandler(vehicle.drivers);
            }
        }

        const onFailure = err => {
            Alert.warning("Vehicle", err.message);
        };


        R.handle(R.vehicle.editDrivers, {
            id: vehicle.id,
            drivers: driverIds
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const onAdd = ({detail}) => {
        let ids = [detail.id, ...vehicle.drivers.map(item => (item.id))];
        save(ids);
    }

    const onEdit = (driver) => {
        app.editDriver(driver.id, vehicle.transporter_id, closeEdit);
    }

    const onRemove = (obj) => {
        Alert.confirm("Remove Driver", `This will remove driver "${obj.name}" from vehicle.\nAre you sure?`, () => removeDriver(obj.id));
    }

    const removeDriver = (id) => {
        let ids = vehicle.drivers.map(item => (item.id)).filter(x => x != id);
        save(ids);
    }

    const closeEdit = (driver) => {
        app.clearDriver();
        if (driver) {
            let item = vehicle.drivers.find(x => x.id == driver.id);
            if (!item) {
                vehicle.drivers = [driver, ...vehicle.drivers];
                let ids = vehicle.drivers.map(item => (item.id));
                save(ids);
            } else {
                item.name = driver.name;
                item.is_active = driver.is_active;
                vehicle.drivers = vehicle.drivers;
            }
        }
    }

    const openModal = () => {
        selectedDrivers = vehicle.drivers.map(item => (item.id));
    }

    const closeModal = (selected) => {
        if (selected) {
            save(selected);
        }
        selectedDrivers = null;
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Drivers
    </div>
    {#if vehicle.id > 0}
        <div class="panel-body p-2 border-bottom">
            <div class="tools-box">
                <DriverSelect transporterId="{ vehicle.transporter_id }"
                              excludeFromSelection="{ vehicle.drivers }"
                              on:select="{ onAdd }"
                              placeholder="add existing driver"/>
                <button class="btn btn-default btn-flex line-height-1 ms-1" title="select from list"
                        on:click="{ openModal }">
                    <AppIcon icon="list" size="16"/>
                </button>
            </div>
        </div>
        {#if vehicle.drivers.length}
            <table class="table table-list">
                <tbody>
                {#each vehicle.drivers as item}
                    <tr class="row-hover">
                        <td>
                            <span class="is-link" class:not-active={ item.is_active < 1}
                                  on:click="{ () => onEdit(item) }">
                                { item.name }
                            </span>
                        </td>
                        <td class="button-column" title="remove driver from vehicle"
                            on:click="{ () => onRemove(item) }">
                            <AppIcon icon="x" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="panel-body panel-pad">
                Vehicle has no drivers.
            </div>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new vehicle in order to add drivers.
        </div>
    {/if}
</div>
{#if selectedDrivers != null}
    <DriverSelectModal transporterId="{ vehicle.transporter_id }" selected={ selectedDrivers }
                       callbackHandler="{ closeModal }"/>
{/if}